var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniformDataFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43,
    fill: "white",
    stroke: "#F68140",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7157 55.9691V18.9113C52.7157 18.7541 52.5862 18.6258 52.4247 18.6258H49.4887C49.3285 18.6258 49.1978 18.7528 49.1978 18.9113V71.7145C49.1978 72.0039 49.5861 72.1087 49.7369 71.8599L58.9561 56.6842C59.0708 56.4943 58.932 56.2533 58.7065 56.2533H53.0026C52.8424 56.2533 52.7116 56.1263 52.7116 55.9678L52.7157 55.9691Z",
    fill: "#F68140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2845 32.0311V69.089C36.2845 69.2461 36.4139 69.3744 36.5754 69.3744H39.5114C39.6716 69.3744 39.8024 69.2474 39.8024 69.089V16.2857C39.8024 15.9963 39.414 15.8915 39.2632 16.1403L30.0414 31.3147C29.9266 31.5046 30.0654 31.7456 30.291 31.7456H35.9949C36.155 31.7456 36.2858 31.8726 36.2858 32.0311H36.2845Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 56,
    fill: "white",
    transform: "translate(30 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniformDataFlow);
export default __webpack_public_path__ + "static/media/uniform_data_flow.51e044163b0664d23a22ce4bb1da1bbd.svg";
export { ForwardRef as ReactComponent };